export const orderStatus = [
  { name: '待支付', value: 'unpaid' },
  { name: '已退款', value: 'refund' },
  { name: '挂单中', value: 'pending' },
  { name: '已支付', value: 'paid' },
  { name: '待收货', value: 'unreceived' },
  { name: '待评价', value: 'unreviewed' },
  { name: '已完成', value: 'finished' },
  { name: '已取消', value: 'cancelled' },
  { name: '退款中', value: 'waiting_confirmed' },
  { name: '已退款', value: 'refunded' },
  { name: '已删除', value: 'discarded' }
]
export const paymentMethods = [
  { name: '现金', value: 'cash_pay' },
  { name: '支付宝线上', value: 'lcsw_ali_pay' },
  { name: '微信线上', value: 'lcsw_wx_pay' },
  { name: '储值卡', value: 'svc_pay' },
  { name: '银行卡', value: 'bank_card' },
  { name: '支付宝线下', value: 'alipay_offline' },
  { name: '微信线下', value: 'wx_pay_offline' },
  { name: '美团-线下', value: 'meituan_pay_offline' }
]
